import { useTranslation } from "react-i18next";

const useEnumData = () => {
  const { t } = useTranslation();

  const DATAYESNO = [
    { text: t("yes"), value: "EVET" },
    { text: t("no"), value: "HAYIR" },
  ];

  const DATAYESNOTENTATIVE = [
    { text: t("yes"), value: "EVET" },
    { text: t("no"), value: "HAYIR" },
    { text: t("tentative"), value: "BELIRSIZ" },
  ];

  const DATADOMESTICINTERNATIONAL = [
    { text: t("domestic"), value: "YURTICI" },
    { text: t("international"), value: "YURTDISI" },
  ];

  const DATALAUNCHTYPE = [
    { text: t("product_launch"), value: "URUN_LANSMANI" },
    { text: t("press_launch"), value: "BASIN_LANSMANI" },
    {
      text: t("csr_project_launch"),
      value: "SOSYAL_SORUMLULUK_PROJE_LANSMANI",
    },
    { text: t("other_project_launch"), value: "DIGER_PROJE_LANSMANI" },
  ];

  const DATAONLINEPHYSICAL = [
    { text: t("online"), value: "ONLINE" },
    { text: t("physical"), value: "FIZIKI" },
  ];

  const DATAINTERNALEXTERNAL = [
    { text: t("internal"), value: "SIRKET_ICI" },
    { text: t("external"), value: "SIRKET_DISI" },
  ];

  const DATAMEETINGTYPE = [
    { text: t("section_meeting"), value: "BOLUM_TOPLANTISI" },
    { text: t("informative_meeting"), value: "BILGILENDIRME_TOPLANTISI" },
    { text: t("other_meeting"), value: "DIGER_TOPLANTI" },
  ];

  const DATAINTERNALCOMMUNICATIONTYPE = [
    { text: t("general_corporate_event"), value: "GENEL_SIRKET_ETKINLIGI" },
    { text: t("travel_club_event"), value: "SEYAHAT_KULUBU_ETKINLIGI" },
    { text: t("running_club_event"), value: "KOSU_KULUBU_ETKINLIGI" },
    { text: t("party_event"), value: "PARTI_ETKINLIGI" },
    { text: t("picnic_event"), value: "PIKNIK_ETKINLIGI" },
  ];

  const DATAYEARENDMEETINGTYPE = [
    { text: t("dealer_meeting"), value: "BAYI_TOPLANTISI" },
    { text: t("service_meeting"), value: "SERVIS_TOPLANTISI" },
    { text: t("distributor_meeting"), value: "DISTRIBUTOR_TOPLANTISI" },
  ];

  const DATAREGIONALMEETINGTYPE = [
    { text: t("dealer_meeting"), value: "BAYI_TOPLANTISI" },
    { text: t("service_meeting"), value: "SERVIS_TOPLANTISI" },
    { text: t("distributor_meeting"), value: "DISTRIBUTOR_TOPLANTISI" },
  ];

  const DATAREGIONALMEALTYPE = [
    { text: t("dealer_meeting"), value: "BAYI_TOPLANTISI" },
    { text: t("service_meeting"), value: "SERVIS_TOPLANTISI" },
    { text: t("distributor_meeting"), value: "DISTRIBUTOR_TOPLANTISI" },
  ];

  const DATATRAVELTYPE = [
    { text: t("campaign"), value: "KAMPANYA" },
    { text: t("product"), value: "URUN" },
    { text: t("distributor"), value: "DISTRIBUTOR" },
  ];

  const DATASPONSORSHIPTYPE = [
    { text: t("sector"), value: "SEKTOR" },
    { text: t("media"), value: "MEDYA" },
    { text: t("sport"), value: "SPOR" },
  ];

  const DATATRAININGSEMINARTYPE = [
    { text: t("training"), value: "EGITIM" },
    { text: t("seminar"), value: "SEMINER" },
  ];

  const DATAMEETINGROOM = [
    { text: "DTAS Plaza Meeting Room Z-A", value: "DTAS_PLAZA_Z_A" },
    { text: "DTAS Plaza Meeting Room Z-B", value: "DTAS_PLAZA_Z_B" },
    { text: "DTAS Plaza Meeting Room Z-C", value: "DTAS_PLAZA_Z_C" },
    { text: "DTAS Plaza Meeting Room Z-D", value: "DTAS_PLAZA_Z_D" },
    { text: "DTAS Plaza Meeting Room 1-A", value: "DTAS_PLAZA_1_A" },
    { text: "DTAS Plaza Meeting Room 2-A", value: "DTAS_PLAZA_2_A" },
    { text: "DTAS Plaza Meeting Room 2-B", value: "DTAS_PLAZA_2_B" },
    { text: "DTAS Plaza Meeting Room 3-A", value: "DTAS_PLAZA_3_A" },
    { text: "DTAS Plaza Meeting Room 3-B", value: "DTAS_PLAZA_3_B" },
    { text: "DTAS Plaza Meeting Room 5-A", value: "DTAS_PLAZA_5_A" },
    { text: "DTAS Plaza Meeting Room 5-B", value: "DTAS_PLAZA_5_B" },
    { text: "DTAS Plaza Meeting Room 6-A", value: "DTAS_PLAZA_6_A" },
    { text: "DTAS FUHA Istanbul Meeting Room", value: "DTAS_FUHA_ISTANBUL" },
    {
      text: "DTAS Plaza SP Konferans Salonu",
      value: "DTAS_PLAZA_SP_KONFERANS",
    },
  ];

  return {
    DATAYESNO,
    DATAYESNOTENTATIVE,
    DATADOMESTICINTERNATIONAL,
    DATALAUNCHTYPE,
    DATAONLINEPHYSICAL,
    DATAINTERNALEXTERNAL,
    DATAMEETINGTYPE,
    DATAINTERNALCOMMUNICATIONTYPE,
    DATAYEARENDMEETINGTYPE,
    DATAREGIONALMEETINGTYPE,
    DATAREGIONALMEALTYPE,
    DATATRAVELTYPE,
    DATASPONSORSHIPTYPE,
    DATATRAININGSEMINARTYPE,
    DATAMEETINGROOM,
  };
};

export default useEnumData;
